module.exports = __webpack_public_path__ + "img/Porto Apartment - 46 of 85.0d9c012e.jpeg";